import { css } from "styled-components/macro";
import { themePalette } from "../theme";

export const alertActionButtonStyles = css`
  width: 30px;
  height: 30px;
  color: ${themePalette.redMedium};

  &:hover {
    background: ${themePalette.redPastel};
  }

  &:focus-visible {
    outline: 2px solid ${themePalette.redMedium};
    outline-offset: 2px;
    background: ${themePalette.redPastel};
  }

  &:disabled {
    color: ${themePalette.greyLight};
  }

  &:disabled:hover {
    background: transparent;
  }
`;
